import "datatables.net";
import "datatables.net-se/css/dataTables.semanticui.css";
import "datatables.net-buttons";
import "datatables.net-buttons-se";
import "datatables.net-buttons-se/css/buttons.semanticui.css";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import {default as i18n} from "i18next";
import {sendPatchRequest, sendPostRequest} from "./apiv4helper";
import {removeEmptyAndUndefinedProps} from "./main";
import { unescape } from 'lodash';

// Constants for change configuration result status
const ChangeStatusEnum = {
    NONE: 0,
    CHANGED: 1,
    NOT_SUPPORTED: 2,
    REJECTED: 3,
    UNKNOWN: 4
};

let batch = false;

function stationConfigurationTable(stationId, results, resultDiv, includeReadonly = true, addRow = false) {
    let data = [];
    $.each(results, function (k, v) {
        if (typeof v !== 'undefined') {
            let row = {};
            let raw = v != null && v.hasOwnProperty("key");
            let value = (v != null && v.hasOwnProperty("value")) ? v.value : "";
            row.key = raw ? v.key : k;
            row.ro = raw ?
                !(
                    v.readonly === false ||
                    (typeof v.readonly === "string" && (
                        v.readonly.toLowerCase() === "false" ||
                        v.readonly === "0"
                    )) ||
                    v.readonly === 0
                ) : true;
            row.value = raw ? value : v;
            row.original = raw ? value : v;
            row.status = "";
            row.removable = false;
            if (row.ro === false || includeReadonly) {
                data.push(row);
            }
        }
    });
    let table = "<table class='ui stackable single line celled small table compact full-width' id='station-configuration-table'>" +
        "<thead>" +
        "<tr><th colspan=5 style='text-align:center; font-weight: bold'>Station Configuration</th></tr>" +
        "<tr style='font-weight: bold; width: 100%'><th class='five wide' style='text-align:left'>Configuration Key</th><th class='six wide' style='text-align: left'>Value</th><th></th><th></th><th class='one wide'></th></tr>" +
        "</thead><tbody></tbody></table>";
    resultDiv.html(table);

    const stationTable = $('#station-configuration-table');
    let dt = stationTable.DataTable(
        {
            //fixedHeader: true,
            searching: false,
            paging: false,
            ordering: false,
            bAutoWidth: false,
            info: false,
            data: data,
            //scrollY: "40vh",
            //scrollCollapse: true,
            autoWidth: false,
            columns: [
                {data: "key"},
                {
                    data: "value",
                    render: function (data, type, row) {
                        if (row.ro === false) {
                            const input = $('<input type="text" value="' + row.value + '" name="configuration-keys[' + row.key + ']" id="' + row.key + '" />');
                            input.css("width", "90%");
                            return input.prop("outerHTML");
                        }
                        return data;
                    }
                },
                {data: "status", visible: false},
                {data: "original", title: "Value", visible: false},
                {
                    data: function (row) {
                        if (row.removable) {
                            return '<i class="icon trash large"></i>';
                        } else {
                            return '';
                        }
                    }
                }
            ],

            //Toggle some classes based on status of the row
            rowCallback: function (row, data, idx) {
                const selector = $('td', row);
                selector.toggleClass('negative', ChangeStatusEnum.REJECTED === data.status ||
                    ChangeStatusEnum.NOT_SUPPORTED === data.status);
                selector.toggleClass('warning', ChangeStatusEnum.UNKNOWN === data.status);
                selector.toggleClass('positive', ChangeStatusEnum.CHANGED === data.status);
            },
            buttons: [
                {
                    extend: "csvHtml5",
                    title: "station_configuration_" + stationId,
                    exportOptions: {
                        columns: [0, 3] //Only export Key and actual Value data
                    }
                }
            ],
            rowId: 'key'
        }
    );

    if (addRow) {
        let $newRowDiv = $('<div class="ui grid">');
        let $input = $('<input class="ui input" id="add-key-input" placeholder="' + i18n.t("batch.addConfigKeyPlaceholder") + '" />');
        $input.on('submit', (e) => {
            e.preventDefault();
            return false;
        });
        let $button = $('<div class="ui button green">' + i18n.t("batch.addConfigKey") + '</div>');
        $newRowDiv.append($('<div class="ui column six wide" />').append($input));
        $newRowDiv.append($('<div class="ui column six wide" />').append($button));

        resultDiv.append($newRowDiv);

        $button.on('click', () => {
            let row = dt.row.add({
                key: $input.val(),
                value: "",
                status: null,
                original: "",
                ro: false,
                removable: true
            });
            dt.draw(false);
            $input.val("");
        });
        stationTable.on('click', 'i.trash', function () {
            dt.row($(this).parents('tr')).remove();
            dt.rows().invalidate().draw();

        })
    }


    //stationTable.css("width", "100%");
}

/**
 *
 * @param {$} table
 * @param {boolean} asObject
 * @returns {Array}
 */
function getStationConfigurationChanges(table, asObject = false) {
    let changesArr = [];
    let changesObj = {};
    table.DataTable().data().each(
        function (d) {
            const elem = $("input[name='configuration-keys[" + unescape(d.key) + "]']");
            if (elem !== 'undefined' && d.value !== elem.val() && !d.ro) {
                if (asObject) {
                    changesObj[elem.attr('name').match(/configuration-keys\[(.*)\]/)[1]] = elem.val();
                } else {
                    changesArr.push({name: elem.attr('name'), value: elem.val()});
                }
            }
        }
    );
    return asObject ? changesObj : changesArr;
}


function validateStationSettingsForm(form, batch=false) {
    let formSettings = {
        inline: true,
        fields: {
            "station-name": {
                optional: batch,
                rules: [
                    {
                        type: 'minLength[5]',
                        prompt: window.langtext.minLength
                    },
                    {
                        type: 'maxLength[50]',
                        prompt: window.langtext.maxLength
                    }
                ]
            },
            "station-address" : {
                optional: true,
                rules: [
                    {
                        type: 'minLength[5]',
                        prompt: window.langtext.minLength

                    },
                    {
                        type: 'maxLength[100]',
                        prompt: window.langtext.maxLength
                    }
                ]
            },
            "station-city" : {
                optional: true,
                rules: [
                    {
                        type: 'minLength[3]',
                        prompt: window.langtext.minLength
                    },
                    {
                        type: 'maxLength[50]',
                        prompt: window.langtext.maxLength

                    }
                ]
            },
            "station-coordinates": {
                optional: true,
                rules: [
                    {
                        type: 'regExp[/^[-]?[\\d]+[.][\\d]+[,][-]?[\\d]+[.][\\d]+/]',
                        prompt: window.langtext.regExp
                    },
                    {
                        type: 'maxLength[40]',
                        prompt: window.langtext.maxLength
                    }
                ]
            },
            "station-hours": {
                optional: true,
                rules: [
                    {
                        type: 'maxLength[250]',
                        prompt: window.langtext.maxLength
                    }
                ]
            },
            "station-location": {
                optional: true,
                rules: [
                    {
                        type: 'minLength[5]',
                        prompt: window.langtext.minLength
                    },
                    {
                        type: 'maxLength[200]',
                        prompt: window.langtext.maxLength
                    }
                ]
            },
            "stationmodelID": {
                optional: batch,
                rules: [
                    {
                        type: 'integer',
                        prompt: window.langtext.unspecifiedRule
                    }
                ]
            },
            "station-max_power": {
                optional: batch,
                rules: [
                    {
                        type: 'decimal[0..9999]',
                        prompt: window.langtext.between
                    }
                ]
            },
            "station-seller": {
                optional: batch,
                rules: [
                    {
                        type: 'integer',
                        prompt: window.langtext.integer
                    }
                ]
            },
            "station-contact": {
                optional: true,
                rules: [
                    {
                        type: 'minLength[5]',
                        prompt: window.langtext.minLength
                    },
                    {
                        type: 'maxLength[400]',
                        prompt: window.langtext.maxLength
                    }
                ]
            },
            "station-points": {
                optional: true,
                rules: [
                    {
                        type: 'integer[6..32]',
                        prompt: window.langtext.between
                    }
                ]
            },
            "custom-evse-id": {
                optional: true,
                rules: [
                    {
                        type: 'uniqueEvseId',
                        prompt: i18n.t("formValidation.unique")
                    },
                    {
                        type: 'regExp[/^[A-Z0-9][A-Z0-9\\*]{4,30}$/]',
                        prompt: i18n.t("formValidation.customEvseId")
                    },
                    {
                        type: 'regExp[/[A-Z\\*]+/]',
                        prompt: i18n.t("formValidation.customEvseId")
                    }

                ]
            },
            "station-sim": {
                optional: true,
                rules: [
                    {
                        type: 'regExp[^[+]*[(]{0,1}[0-9]{3,4}[)]{0,1}[-\\s\\./0-9]*$|eth]',
                        prompt: window.langtext.regExp
                    }
                ]
            },
            "sim-iccid": {
                optional: true,
                rules: [
                    {
                        type: 'regExp[^[:A-Za-z0-9 _.-]+$]',
                        prompt: window.langtext.regExp
                    }
                ]
            }
        }
    };

    form.form(formSettings);

    form.form('validate form');

    if (getFormattedAuthMode(form) === '') {
        alert(i18n.t("formValidation.authMode"));
        return false;
    }

    return form.form('is valid');
}

function getFormData(form, batchMode=false) {
    batch = batchMode;
    const coordinatesFormValues = getFieldVal(form, "input[name='station-coordinates']");
    // Split lat and lng values to new array
    const coordinates = (coordinatesFormValues === undefined) ?
        false :
        (coordinatesFormValues === "" ?
                ['', ''] :
                coordinatesFormValues.trim().split(',')
        );

    const fixedConnector = getFieldVal(form, "input[name='fixed-connector']", "checkbox");

    const fields = {
        name: getFieldVal(form, "input[name='station-name']"),
        sellerId: getFieldVal(form, "#station-seller"),
        poolId: getFieldVal(form, "#station-pool"),
        locationId: getFieldVal(form, "#station-location-id"),
        typeId: getFieldVal(form, "#station-model-id"),
        location: {
            place: getFieldVal(form, "textarea[name='station-location']"),
            contact: getFieldVal(form, "input[name='station-contact']"),
            openHours: getFieldVal(form, "input[name='station-hours']"),
            address: getFieldVal(form, "input[name='station-address']"),
            city: getFieldVal(form, "input[name='station-city']"),
            postCode: getFieldVal(form, "input[name='post-code']"),
            accessibility: getFieldVal(form, "input[name='station-accessibility']"),
            type: getFieldVal(form, '.location-type.dropdown', 'dropdown'),
            coordinates: {
                lat: coordinates[0],
                lng: coordinates[1]
            }
        },
        stationMove: getFieldVal(form, "input[name='station-move']:checked") ,
        eichrechtType: getFieldVal(form, '.eichrecht-type.dropdown', 'dropdown'),
        fixedConnector: fixedConnector,
        connectorInfo: fixedConnector ? getArrayFieldVal(form, "[name^='connector-info']") : undefined,
        currentPowerLimit: getFieldVal(form, "input[name='station-points']"),
        customEvseId: getFieldVal(form, "input[name='custom-evse-id']"),
        iccid: getFieldVal(form, "input[name='sim-iccid']"),
        allowOverride: form.find("input[name='allow_override']").prop('checked'),
        maxPower: getFieldVal(form, "input[name='station-max_power']"),
        meta: {
            reservable: getFieldVal(form, "input[name='reservable']", "checkbox"),
            freeUsage: getFieldVal(form, "input[name='free-usage']", "checkbox"),
            vpnEnabled: getFieldVal(form, "input[name='vpn-connection']", "checkbox"),
            onetimePaymentSupport: getFieldVal(form, "input[name='onetime-enabled']", "checkbox"),
            hiddenStation: getFieldVal(form, "input[name='hidden-station']", "checkbox"),
            authModes: getFormattedAuthMode(form)
        },
        simNumber: getFieldVal(form, "input[name='station-sim']")
    };

    return removeEmptyAndUndefinedProps(fields);
}

function getFieldVal(form, selector, extra = "") {
    const $f = form.find(selector);
    if (batch && !$f.hasClass("batch-field-edited") && !$f.parent().hasClass("batch-field-edited")) {
        return undefined;
    }
    if (extra === "dropdown") {
        return $f.length > 0 ? $f.dropdown('get value') : undefined;
    }
    if (extra === "checkbox") {
        return $f.prop("checked");
    }
    return $f.val();
}

function getArrayFieldVal(form, selector) {
    let values = [];
    $(form).find(selector)
        .map(function () {
            const name = $(this).attr('name').split(/\[|\]/g)
            if (values[parseInt(name[1])] === undefined) {
                values[parseInt(name[1])] = {[name[3]]: $(this).val()}
            } else {
                values[parseInt(name[1])][name[3]] = $(this).val()
            }
        }).get()
    let arrangedValue = []
    values.forEach((connector) => {
        arrangedValue = [...arrangedValue, connector]
    })

    return arrangedValue;
}
function updateStation(stationId, data, successCb, errorCb) {
    sendPatchRequest(`/admin/stations/${stationId}?checkHiddenStationField=true`, data)
        .done(successCb)
        .fail(errorCb);
}

function getFormattedAuthMode(form) {
    let authModes = '';
    $.each(form.find("input[name='auth-mode']:checked"), function(){
        authModes += $(this).val() + ',';
    });
    authModes = authModes.slice(0, -1);
    return authModes;
}

export {
    ChangeStatusEnum,
    stationConfigurationTable,
    getStationConfigurationChanges,
    validateStationSettingsForm,
    getFormData,
    updateStation,
}
